export enum LOCAL_DATA {
    random = 'RANDOM_VALUE',
    sub = 'SUB_COMP_OBJECT',
    component = 'COMP_OBJECT',
    marketingAd = 'MARKETING_AD',
    sub_2th = 'SUB_2th_COMP_OBJECT',
}